import * as React from 'react';
import { ButtonBase, ButtonBaseProps, Typography } from '@material-ui/core';
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { GridItem } from 'components/GridItem';
import { GridContainer } from 'components/GridContainer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
    image: {
      position: 'relative',
      height: 200,
      width: '100%',
      '&:hover, &$focusVisible': {
        zIndex: 1,
        '& $imageBackdrop': {
          opacity: 0.15,
        },
      },
    },
    focusVisible: {},
    imageSrc: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    imageBackdrop: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.7) 100%)',
      opacity: 0,
      transition: theme.transitions.create('opacity'),
    },
  }),
);

interface IProps extends ButtonBaseProps {
  imageUrl: string;
  title: string;
  width?: string;
  height?: string;
  onClicked: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const IconButton: React.FC<IProps> = ({ imageUrl, title, width, height, onClicked }) => {
  const classes = useStyles();

  return (
    <GridContainer className={classes.root}>
      <GridItem>
        <ButtonBase
            focusRipple
            className={classes.image}
            onClick={onClicked}
            style={{
              width: width ?? '10vw',
              height: height ?? '10vw',
              margin: '1%',
            }}
          >
            <span
              className={classes.imageSrc}
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
            />
            <span className={classes.imageBackdrop} />
          </ButtonBase>
      </GridItem>

      <GridItem>
        <Typography
          component="span"
          variant="subtitle1"
          color="inherit"
        >
          {title}
        </Typography>
      </GridItem>
    </GridContainer>
  );
};
